import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item", "menu"];

  connect() {
    this.defaultItem = this.itemTargets.find(
      (item) => item.dataset.navDefault === "true",
    );
    this.setActive(this.defaultItem);
  }

  activate(event) {
    this.setActive(event.currentTarget);
  }

  resetDefault() {
    this.setActive(this.defaultItem);
  }

  // Mobile hamburger disclosure — the hover-driven `item`/`activate` machinery
  // above is desktop-only (that row is `hidden` below `sm:`), this is its own,
  // separate concern.
  openMenu() {
    this.menuTarget.showModal();
  }

  closeMenu() {
    this.menuTarget.close();
  }

  setActive(activeItem) {
    this.itemTargets.forEach((item) => {
      const isActive = item === activeItem;
      // `.nav-item-active` (application.tailwind.css), not a raw color class — that
      // one hardcoded hex only ever read correctly against the permanent dark/blue
      // background this page used to have in every theme; this name carries its own
      // light/dark pair instead.
      item.classList.toggle("nav-item-active", isActive);
    });
  }
}
